import { render, staticRenderFns } from "./section_switch.vue?vue&type=template&id=2178ce6e"
import script from "./section_switch.js?vue&type=script&lang=js&external"
export * from "./section_switch.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports